import card14 from './14.jpg';
import card15 from './15.jpg';
import card16 from './16.jpg';
import card17 from './17.jpg';
import card18 from './18.jpg';
import card19 from './19.jpg';
import card20 from './20.jpg';
import card21 from './21.jpg';
import card22 from './22.jpg';
import card23 from './23.jpg';
import card24 from './24.jpg';
import card25 from './25.jpg';
import card26 from './26.jpg';

const cards_data1 = [
    {
        image:card14,
        
    },
    {
        image:card15,
        
    },
    {
        image:card16,
        
    },
    {
        image:card17,
       
    },
    {
        image:card18,
        
    },
    {
        image:card19,
        
    },
    {
        image:card20,
        
    },
    {
        image:card21,
        
    },
    {
        image:card22,
        
    },
    {
        image:card23,
        
    },
    {
        image:card24,
        
    },
    {
        image:card25,
        
    },
    {
        image:card26,
        
    }
]
export default cards_data1;